export const recipeFilters = [
  { label: "High Protein",   value: "high-protein" },
  { label: "Quick",          value: "quick" },
  { label: "Budget",         value: "budget" },
  { label: "Under 500 kcal", value: "under-500-kcal" },
];

export const allRecipeFilters = [
  { label: "High Protein",   value: "high-protein" },
  { label: "Quick",          value: "quick" },
  { label: "Budget",         value: "budget" },
  { label: "Under 500 kcal", value: "under-500-kcal" },
  { label: "Breakfast",      value: "breakfast" },
  { label: "Lunch",          value: "lunch" },
  { label: "Dinner",         value: "dinner" },
];
